module.exports = __webpack_public_path__ + "img/milano-logo.56df0ed.png";